import React from "react";
import { useRef } from 'react'
import QRCode from "qrcode.react";
import axios from 'axios';
import {getCsrfToken} from '../commons/authenticityToken';

const ModalInterviewLink = (props) => {
    axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken(); 
    const buttonEl = useRef(null);
    
    
    function copyButton() {
      if (window.clipboardData){ // IE対応
        window.clipboardData.setData("Text" ,"https://" + location.hostname +"/interview/index?interview_key=" + props.interviewKey);
      } else {
        navigator.clipboard.writeText("https://" + location.hostname +"/interview/index?interview_key=" + props.interviewKey);
      }
    }

    function redirectToInterview() {
        location.href = ("https://" + location.hostname + "/interview/index?interview_key=" + props.interviewKey + "&is_lend=true")  
    }

    function getFilteredDInterviewDetails(status, flg) {
      if (flg === true) {
        const newIndexProps = props.defaultIndexProps.filter(dInterviewDetail => dInterviewDetail.status === status);
        return newIndexProps;
      } else {
        const newIndexProps = props.defaultIndexProps.filter(dInterviewDetail => dInterviewDetail.status === status && dInterviewDetail.display_flg === 1);
        return newIndexProps;
      }
    }

    function updateDisplayFlg(dInterviewDetailId) {
      axios.patch(
        '/api/internal/interview/update_display_flg', {
          dInterviewDetailId: dInterviewDetailId
        })
        .then(function (response) {
          buttonEl.current.click();
          // 0は更新処理前に非表示、1は更新処理前に表示されていた状態
          const i = props.defaultIndexProps.findIndex(({id}) => id === dInterviewDetailId);
          if (props.display_flg === 1) {
            props.defaultIndexProps[i].display_flg = 0;
          } else {
            props.defaultIndexProps[i].display_flg = 1;
          }
          props.updateIndexProps(props.defaultIndexProps);
        })
        .catch(error => {
          console.log(error.response)
        });
    }

    function deleteDInterviewDetail(dInterviewDetailId) {
      if (!(window.confirm('本当に削除しますか？'))) {
        return null;
      }
      axios.patch(
        '/api/internal/interview/delete_d_interview_detail', {
          dInterviewDetailId: dInterviewDetailId
        })
        .then(function (response) {
          buttonEl.current.click();
          const newDefaultIndexProps = props.defaultIndexProps.filter(dInterviewDetail => !(dInterviewDetail.id === dInterviewDetailId));
          props.updateIndexProps(newDefaultIndexProps);
        })
        .catch(error => {
          console.log(error.response)
        });
    }

      // LINE送信
    function sendLineMessage(){
      axios.post(
        '/api/internal/messages/send_line_message', {
            m_patient_id: props.patientId,
            url: "https://" + location.hostname + "/interview/index?interview_key=" + props.interviewKey,
        })
        .then(function () {
          const element = document.getElementById("send_complate_button");
          element.click();
        })
        .catch(error => {
          const element = document.getElementById("send_error_button");
          element.click();
        }); 
    }

    return (
      <>
        <div className="modal fade" data-backdrop="static" id="modalInterviewLink">
          <div className="modal-dialog modal-width">
            <div className="modal-content">
              <div className="modal-header bg-success">
                <button type="button" className="close" data-dismiss="modal" ref={buttonEl}>
                  <span aria-hidden="true">&#215;</span><span className="sr-only">閉じる</span>
                </button>
                <h4 className="modal-title text-center modal-title-align">
                  {props.patientName} 様の先確認リンク
                </h4>
              </div> {/* /modal-header */}

              <div className="modal-body interview-status-modal-body">
                <div className="form-group">
                  <input
                    key="clipboard"
                    type="text"
                    className="form-control"
                    readOnly={true}
                    value={"https://" + location.hostname +"/interview/index?interview_key=" + props.interviewKey}
                  />
                  <button type="button" className="interview-link-modal-button" onClick={() => copyButton()} style={{marginRight: "10px"}}>
                    コピー
                  </button>
                  <button type="button" className="interview-link-modal-button" disabled={!props.line_linked} onClick={() => sendLineMessage()} style={{marginLeft: "10px"}}>
                    LINE
                  </button>
                </div>

                <hr style={{width: "400px"}} />

                <div className="form-group">
                  <div>QRコードを読み取ってください</div>
                  <QRCode value={"https://" + location.hostname + "/interview/index?interview_key=" + props.interviewKey} size="200"/>
                </div>

                <hr style={{width: "400px"}} />

                <div className="form-group">
                  <button type="button" className="pager-button bg-white" onClick={() => redirectToInterview()}>スタート</button>
                </div>

                <hr style={{width: "400px"}} />

                <div className="form-group">
                  <button type="button" className="interview-link-modal-button" onClick={() => updateDisplayFlg(props.id)} style={{marginRight: "10px"}}>
                    {props.display_flg === 1 ? "非表示" : "再表示"}
                  </button>
                  <button type="button" className="interview-link-modal-button" onClick={() => deleteDInterviewDetail(props.id)} style={{marginLeft: "10px"}}>
                    削除
                  </button>
                </div>

              </div> {/* /modal-body */}
            </div> {/* /modal-content */}
          </div> {/* /modal-dialog */}
        </div> {/* /modal */}

        <input id="send_complate_button" type="hidden"　data-toggle="modal" data-target="#send_complate_modal"/>
        <input id="send_error_button" type="hidden" data-toggle="modal" data-target="#send_error_modal"/>
        {/* 送信完了モーダル */}
        <div className="modal fade" data-backdrop="static" id="send_complate_modal">
          <div className="sw-modal-content">
            <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
            <div className="swal2-icon swal2-success animate-success-icon" style={{display: "block"}}>
              <span className="line tip"/> <span className="line long"/><div className="placeholder"/><div className="fix"/>
            </div>
              <h2>メッセージ送信（LINE）</h2>
              <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                メッセージ送信（LINE）が完了しました。<br />
              </div>
              <button type="button" className="sw-modal-btn" data-dismiss="modal">閉じる</button>
            </div>
          </div>
        </div>

        {/* 送信失敗モーダル */}
        <div className="modal fade" data-backdrop="static" id="send_error_modal">
          <div className="sw-modal-content">
            <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
              <div className="swal2-icon swal2-error animate-error-icon" style={{display: "block"}}>
                <span className="x-mark animate-x-mark">
                  <span className="line left"/><span className="line right"/>
                </span>
              </div>
              <h2>メッセージ送信（LINE）</h2>
              <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                メッセージ送信（LINE）に失敗しました。<br />
              </div>
              <button type="button" className="sw-modal-btn" data-dismiss="modal">閉じる</button>
            </div>
          </div>
        </div>
        
      </>
    );
};

export default ModalInterviewLink;